module.exports = __webpack_public_path__ + "img/lemon_and_mint_0.b0c8754b.png";